import gql from 'graphql-tag';

const getStockAssetRecordsQuery = gql`
  query GetStockAssetRecords($input: StockAssetRecordsInput!) {
    stockAssetRecords(input: $input) {
      assetId
      purchased
      firstUseOutputId
      source
      cost
    }
  }
`;

const getStockAssetRecords = (organisationIdProp) => ({
  query: getStockAssetRecordsQuery,
  skipCache: true,
  module: 'stock-assets',
  buildVariables: ({
    assetIds,
    organisationId
  }) => ({
    input: {
      assetIds,
      organisationId: organisationId || organisationIdProp
    }
  })
});

export default getStockAssetRecords;